<template>
  <a-space
    class="site-input-group-wrapper"
    direction="vertical"
    size="middle"
    style="position: absolute; top: 0"
  >
    <a-input-group compact>
      <a-select
        v-model:value="formState.type"
        style="width: 140px"
        :options="typeList"
        @change="onTypeListChange"
      />
      <a-select
        v-if="formState.type === 'Amount' || formState.type === 'Up to Amount'"
        v-model:value="formState.currencyName"
        style="width: 80px"
        :options="currencyList"
      />
      <a-input-number
        v-model:value="formState.value"
        :class="(formState.type === 'Up to Amount' || formState.type === 'Amount') ? 'cus-input-rightboder' : 'cus-input-noboder'"
        :style="(formState.type === 'Up to Amount' || formState.type === 'Amount') ? 'width: 120px;' : 'width: 100px;'"
      >
        <template
          v-if="formState.type === 'Percent' || formState.type === 'Up to Percent'"
          #addonAfter
        >
          %
        </template>
      </a-input-number>
      <span
        style="margin-left: 5px; margin-top: 5px"
      >{{ prefix }} for KOL:
        {{ (formState.type === 'Up to Percent' || formState.type === 'Up to Amount') ? 'Up to' : '' }}
        {{ (formState.type === 'Up to Amount' || formState.type === 'Amount') ? currencyList.filter(item => item.value==formState.currencyName)[0]?.label : '' }}
        {{ (baseRatio * formState.value).toFixed(2) }}
        {{ (formState.type === 'Up to Percent' || formState.type === 'Percent') ? '%' : '' }}
      </span>
    </a-input-group>
  </a-space>
</template>

<script setup>
import { ref, watch, toRaw, reactive } from 'vue'
const props = defineProps({
  settings: { type: Object, default: undefined },
  prefix: { type: String, default: '' },
  onTypeChange: { type: Function, default: undefined },
  modelValue: {
    type: Object,
    default: () => ({ type: 'Percent', value: 0, currencyName: '' }), // 默认值
  },
})
const typeList = ref([])
const currencyList = ref([])
const baseRatio = ref(null)

const prefix = ref(props.prefix)

const formState = reactive({
  ...toRaw(props.modelValue),
})

const onTypeListChange = (v) => {
    if (v === 'Up to Amount' || v === 'Amount') {
        formState.currencyName = 'USD';
    } else {
        formState.currencyName = '';
    }
    if (props.onTypeChange) {
      props.onTypeChange(v)
    }
}

// 监听父组件的 props 更新，更新本地的状态
watch(
  () => props.settings,
  (newValue) => {
    formateData(toRaw(newValue))
  }
)

watch(
  () => props.modelValue,
  (newValue) => {
    formState.type = newValue.type;
    formState.value = newValue.value;
    formState.currencyName = newValue.currencyName;
  }
)

watch(
  () => formState,
  (newVal) => {
    // 使用 toRaw() 将响应式的 Proxy 转换为普通对象
    emit('update:modelValue', newVal)
  },
  { deep: true }
)

// 定义事件触发器，更新父组件的数据
const emit = defineEmits(['update:modelValue'])

emit('update:modelValue', formState)

// 处理输入事件
// const updateValue = () => {
//   // 触发事件，将新值传递给父组件
//   emit('update:modelValue', formState);
// };

const formateData = (data) => {
  baseRatio.value = data.baseRatio
  typeList.value = data.typeList?.map((item) => {
    return {
      value: item,
      label: item,
    }
  })
  currencyList.value = data.currencyList?.map((item) => {
    return {
      value: item.name,
      label: item.symbol + item.name,
    }
  })
}

props.settings && formateData(toRaw(props.settings))
</script>

<style lang="less">
.cus-input-noboder {
  border-radius: 0;
}
.cus-input-rightboder {
  border-radius: 0 6px 6px 0 !important;
}
</style>